export async function zipSearch() {

    document.addEventListener( "click", ocwZipSearch );
    document.addEventListener( "keydown", ocwZipEnter );

    async function ocwZipSearch(e){
        var button = e.target;
        const zipMsg = document.querySelector("#ocw-zip-message");
        if(button.id == "ocw-google-button"){
            e.preventDefault();
            const searchTerm = document.querySelector("#ocw-google-zip");
            zipMsg.style.display = "none";
            if(searchTerm.value.search(/^[0-9]{5}$/) > -1){
                searchTerm.classList.remove("error");
                let searchLocation = await getZipLocation( searchTerm.value );
                if(searchLocation){
                    window.open( 'https://' + location.hostname + '/locations/?search=' + searchTerm.value + '&partner=all' );
                }else{
                    zipMsg.style.display = "flex";
                }
            }else{
                searchTerm.classList.add("error");
            }
        }else if(zipMsg) {
            if(!zipMsg.contains(e.target)){
                zipMsg.style.display = "none";
            }
        }
    }
        
    function ocwZipEnter(e){
        const searchButton = document.querySelector("#ocw-google-button");
        if (searchButton && e.key === 'Enter') {
            searchButton.click();
        }
    }

    async function getZipLocation( zipCode ){
        const zipUrl = new URL("/wp-json/ocwlocations/checkzip", window.location.origin);
        zipUrl.searchParams.set('zip', zipCode);
        const response = await fetch(zipUrl);

        if (!response.ok) {
        // non 200 response
        throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        let storesExist = await response.json();

        return storesExist;
    }
}